import ReportEditConfigController from './ATReportEditConfigController'
import ThreeLevelReportGroupingSelector from '../ThreeLevelReportGroupingSelector'
import {ReportGroupingLevel} from '../constants'
import DisplayedDataSelector from '../../controls/displayed_data_radiogroup_controls_bs_report'

export default class BillingSummaryReportEditConfigController extends ReportEditConfigController {}

BillingSummaryReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    var self = this;
    var reportParameters = this.makeReportParamsAccordingToFeatures( config.reportParameters );
    
    this.configChangedCallback = config.changeCallback;
    var configChanged = function () { self.configChanged(); };

    this.reportAuthorizationInfo = config.reportAuthorizationInfo

    this.approvedTTFilter = this.addApprovedTTFilter(reportParameters.timeApprovalStatus, configChanged);

    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    var groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];
    this.groupingSelector = new ThreeLevelReportGroupingSelector().init( {
                                                                             selectorId: "reportGroupingSelector",
                                                                             enableNoneFirstGrouping: true,
                                                                             enableGroupByBillingType: false,
                                                                             enableGroupByUsers: true,
                                                                             enableGroupByUserGroups:  EnabledFeatures.UGR || this.checkGroupingLevel(ReportGroupingLevel.USER_GROUP, groupingLevelsSelection),
                                                                             includeTTCommentsInDetailsLevel: true,
                                                                             groupingLevelsSelection: groupingLevelsSelection,
                                                                             changesCallback: function() { self.removeGroupingLevelsSelectionError(); configChanged();}
                                                                         });
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);
    
    this.displayedDataSelector = new DisplayedDataSelector().init("billingStatusFilter", reportParameters.reportInfo, configChanged);
    this.chooseTypeSelector = new ChooseTypeSelector().init(reportParameters.reportType, configChanged);
    return this;

};

BillingSummaryReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        timeApprovalStatus: this.approvedTTFilter.getValue(),
        reportType: this.chooseTypeSelector.getValue(),
        reportInfo: this.displayedDataSelector.getValue(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        reportAuthorizationInfo: this.reportAuthorizationInfo,
    };
};

BillingSummaryReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.approvedTTFilter.setActiveItemByValue(this.initReportParameters.timeApprovalStatus, true);
    this.chooseTypeSelector.setValue(this.initReportParameters.reportType);
    this.displayedDataSelector.setValue(this.initReportParameters.reportInfo);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
};

BillingSummaryReportEditConfigController.prototype.validate = function()
{
    this.errors = [];

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length == 0;
};

BillingSummaryReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};

BillingSummaryReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/BillingSummaryReportEditConfigController.js